import PercentualPriceAdjustmentModal from "../Components/Voss/PriceAdjustment/PriceAdjustmentModal";

const Modals = {
    SupportLogin: 1,
    SendDesktopVersion: 2,
    UserSearch: 3,
    NonCustomerEmail: 4,
    SendMovie: 5,
    SendDemoEmail: 6,
    VonAccountInfo: 7,
    EditVossAndVbCustomer: 8,
    CreateSaasCustomer: 9,
    CreateCustomer: 10,
    CollaborationTermination: 11,
    EditAppConfiguration: 12,
    PriceAdjustmentModal: 13,
    EditCustomerConnections: 14,
    SendLeads: 15,
    CompensationModal: 16,
    EducationModal: 17,
    AttendedOnboardingsModal: 18,
    ProductInformationModal: 19,
    ConfirmDeleteModal: 20,
    SubscriptionTermination: 21,
    ProductGroupTermination: 22,
    CreateCustomerDiscountAgreement: 23,
    ConfirmOrderModal: 24,
    NewVonEmployeeModal: 25,
    RepublishEventModal: 27,
    EditVbCustomer: 28,
    EditVossCustomer: 29,
    LicenseTermination: 30,
    ConfirmSubscriptionChange: 31,
    ReactivateSubscriptionModal: 32,
    InternalLeadEmail: 33,
    Edit2Fa: 34,
    VossTierSelect: 35,
    AddVossDiscountModal: 36,
    SendPriceForApprovalModal: 37,
    CustomerEmailHistory: 38,
    SendInvoiceCopy: 39,
    ReleaseAnnouncement: 40,
    CopyPackagePlan: 41,
    DeletePackagePlan: 42,
    CancelPackageScheduledChange: 43,
    DeletePackageTier: 44,
    DeletePackageChargePlan: 45,
    ChangePackageVersionStatus: 46,
    CreatePackageVersion: 47,
    ToggleVossFeatureFlag: 48,
    DeleteVossFeatureFlag: 49,
}

export default Modals;